module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('privacy-terms')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e74af8ae!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/privacyTerms/PrivacyTerms.vue
// module id = 1398
// module chunks = 1